import { PayloadAction } from '@reduxjs/toolkit';
import { initialState } from '.';
import { setCouplingsPayload } from './types';

export const reducers = {
  setCoupling(state, action: PayloadAction<setCouplingsPayload>) {
    state.isLoading = true;
  },
  setCouplingSuccess(state, action: PayloadAction<any>) {
    state.isLoading = false;
    state.data = action.payload;
    state.error = null;
  },
  setCouplingFailure(state, action: PayloadAction<any>) {
    state.isLoading = false;
    state.data = initialState.data;
    state.error = action.payload;
  },
  clearCouplingsData(state) {
    state.isLoading = false;
    state.data = initialState.data;
    state.error = null;
  },
};
